/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFAggregationFindingAssets
 */
export interface CRSFAggregationFindingAssets {
    /**
     * 
     * @type {string}
     * @memberof CRSFAggregationFindingAssets
     */
    asset: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFAggregationFindingAssets
     */
    found: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFAggregationFindingAssets
     */
    port: string;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFAggregationFindingAssets
     */
    shared: boolean;
    /**
     * 
     * @type {string}
     * @memberof CRSFAggregationFindingAssets
     */
    source?: string;
}

/**
 * Check if a given object implements the CRSFAggregationFindingAssets interface.
 */
export function instanceOfCRSFAggregationFindingAssets(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "asset" in value;
    isInstance = isInstance && "found" in value;
    isInstance = isInstance && "port" in value;
    isInstance = isInstance && "shared" in value;

    return isInstance;
}

export function CRSFAggregationFindingAssetsFromJSON(json: any): CRSFAggregationFindingAssets {
    return CRSFAggregationFindingAssetsFromJSONTyped(json, false);
}

export function CRSFAggregationFindingAssetsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFAggregationFindingAssets {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'asset': json['asset'],
        'found': json['found'],
        'port': json['port'],
        'shared': json['shared'],
        'source': !exists(json, 'source') ? undefined : json['source'],
    };
}

export function CRSFAggregationFindingAssetsToJSON(value?: CRSFAggregationFindingAssets | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'asset': value.asset,
        'found': value.found,
        'port': value.port,
        'shared': value.shared,
        'source': value.source,
    };
}

